module.exports = __webpack_public_path__ + "img/mobile/General/spelser@1x.png?0.0.53";